import TextFieldControl from "components/form/TextFieldControl";
import VALIDATION from "helpers/validation";
import useIsCreate from "hooks/useIsCreate";
import AvailableRangeControl from "pages/Testing/view/components/AvailableRangeControl";
import { CompetencyMapOptionList, ScenarioOption } from "pages/Testing/view/types";
import { UseFormReturn } from "react-hook-form";
import { InfoInputs } from "../types";
import CompetencyMapInfo from "./CompetencyMapInfo";
import TrialInfo from "./TrialInfo";

interface InfoTabRightProps {
  competencyMaps: CompetencyMapOptionList;
  competencyMapsLoading: boolean;
  scenarios: ScenarioOption[] | undefined;
  scenariosLoading: boolean;
  isEditing: boolean;
  form: UseFormReturn<InfoInputs>;
}

const InfoTabRight = ({
  competencyMaps,
  competencyMapsLoading,
  scenarios,
  scenariosLoading,
  isEditing,
  form,
}: InfoTabRightProps) => {
  const isCreate = useIsCreate();

  return (
    <>
      <TextFieldControl
        name='title'
        label='Название тестирования'
        disabled={!isEditing}
        rules={{ ...VALIDATION.competencyMapTitle }}
      />
      <TextFieldControl
        name='comment'
        label='Комментарий к тестированию'
        minRows={6}
        disabled={!isEditing || isCreate}
        multiline
      />
      {/* TODO: поменять на disabled={!isEditing}, когда добавятся поля в UpdateTrialInput */}
      <AvailableRangeControl disabled={!isCreate} />
      <CompetencyMapInfo
        competencyMaps={competencyMaps}
        isEditing={isCreate && isEditing}
        competencyMapsLoading={competencyMapsLoading}
        scenarios={scenarios}
        scenariosLoading={scenariosLoading}
      />
      <TrialInfo form={form} />
    </>
  );
};

export default InfoTabRight;
